import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { Tarifa } from './tarifa';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-tarifa-modal-update',
  templateUrl: './tarifa-modal-update.component.html'
})
export class TarifaModalUpdateComponent extends BaseModalUpdateComponent<Tarifa> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Tarifa>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
